import React from 'react';
import { connect } from 'redux-zero/react';
import { DsNumber } from '@tokenyico/design-system/dist/reactJS';

const TokenAmountCell = connect(({ holder }) => holder)(({ selectedToken, amount }) => {
  return (
    <div className="_flex-align-center" style={{ flexWrap: 'nowrap' }}>
      <img className="_m:right(1)" width="16px" src={selectedToken?.image} alt="token logo" />
      <span>
        <DsNumber number={amount} currency={selectedToken.symbol} />
      </span>
    </div>
  );
});
export default TokenAmountCell;
